import axios from "axios";
import decode from "jwt-decode";

axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

let URL = {
  MOL_SEARCH: "/perseus/mol_search",
  CRYSTAL_SEARCH: "/perseus/crystal_search",
  REACTION_SEARCH: "/perseus/reaction_search",
  DETAIL: "/perseus/detail",
  AUTH: "/public/auth", // get获取验证码  post校验验证码
  SIGN_UP: "/public/sign_up",
  SIGN_IN: "/public/sign_in",
  SIGN_OUT: "/account/sign_out", // 注销
  ACCOUNT: "/account", // 账户信息总览
  MODIFY: "/account/modify", // 更新用户信息
  RESETPWD: "/account/modify_pwd", // 重置密码
  REFRESHTOKEN: "/public/token_refresh", // post
  FORGETPWD: "/public/forget_password", // post  找回密码邮件
  FINDBACK: "/account/find_back", //post  找回密码
  ACTIVE: "/account/active", // 激活
  SMILESTOFORMULA: "/perseus/convert?source=smiles&target=formula", // smiles to formula
  REACTIONTOFORMULA: "/perseus/convert?source=reaction&target=formula", // smiles to formula
  SMILESTOSVG: "/perseus/render?type=smiles", //  smilesToSvg
  DOWNLOAD: "/perseus/download", // 下载
  REACTIVE: "/public/reactive",
  ALIPAY: "/trade/pay", //点击支付接口
  ALIQUERT: "/trade/query", //查询订单的支付结果
  ALIORDER: "/trade/order", // 查询所有订单
  ALIINVOICE: "/trade/invoice", // 订单开票接口
};

const User = {
  operateAuth(methods, data) {
    // 验证码相关
    if (methods === "get") {
      return axios.get(URL.AUTH);
    } else if (methods === "post") {
      return axios.post(URL.AUTH, data);
    }
  },
  activeAccount(data) {
    return axios.get(URL.ACTIVE, data);
  },
  reactive(data) {
    return axios.post(URL.REACTIVE, data);
  },
  signUp(user) {
    // email pwd
    return axios.post(URL.SIGN_UP, user);
  },
  signIn(user) {
    // email password
    return axios.post(URL.SIGN_IN, user);
  },
  signOut() {
    return axios.post(URL.SIGN_OUT);
  },
  resetPwd(user) {
    // email password newPwd
    return axios.post(URL.RESETPWD, user);
  },
  forgetPassword(data) {
    return axios.post(URL.FORGETPWD, data);
  },
  findBackPassword(data) {
    return axios.post(URL.FINDBACK, data);
  },
  getUserInfo(data) {
    return axios.get(URL.ACCOUNT, {
      params: data,
    });
  },
  changeUserInfo(userInfo) {
    return axios.post(URL.MODIFY, userInfo);
  },
  molSearch(data) {
    return axios.post(URL.MOL_SEARCH, data); // id查detail  数组查list
  },
  crystalSearch(data) {
    return axios.post(URL.CRYSTAL_SEARCH, data); // id查detail  数组查list
  },
  reactionSearch(data) {
    //
    return axios.post(URL.REACTION_SEARCH, data);
  },
  smilesToSvg(data) {
    return axios.post(URL.SMILESTOSVG, data);
  },
  smilesToFormula(data) {
    return axios.post(URL.SMILESTOFORMULA, data);
  },
  reactionToFormula(data) {
    return axios.post(URL.REACTIONTOFORMULA, data);
  },
  refreshToken(data) {
    return axios.post(URL.REFRESHTOKEN, data);
  },
  download() {
    return axios.post(URL.DOWNLOAD);
  },
  aliPay(data) {
    return axios.post(URL.ALIPAY, data);
  },
  aliQuery(data) {
    return axios.post(URL.ALIQUERT, data);
  },
  aliOrder(data) {
    return axios.post(URL.ALIORDER, data);
  },
  aliInvoice(data) {
    return axios.post(URL.ALIINVOICE, data);
  },
};

/**
 * 以下为刷新 token
 */

// 是否正在刷新 token, 正在刷新,则缓存期间要进行的请求,刷新后再重新请求
window.isRefreshing = false;
// 被挂起的请求数组
let refreshSubscribers = [];

// 获取 refresh_token
function getRefreshToken() {
  return JSON.parse(window.localStorage.getItem("refreshToken"));
}

// 缓存刷新token期间的请求到数组中
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}

// 重新发起请求（refreshSubscribers 数组中的请求得到新的token之后会自执行，用新的token去请求数据）
function onRrefreshed(token) {
  refreshSubscribers.map((cb) => cb(token));
}

// access_tokrn 是否过期
function isTokenExpired() {
  let accessToken = decode(
    JSON.parse(window.localStorage.getItem("accessToken"))
  );
  let currentTime = new Date();
  // 五分钟后过期也会更新
  return currentTime.getTime() + 300000 >= parseInt(accessToken.expiredAt);
}

// refresh_token 是否过期
function isRefreshTokenExpired() {
  let refreshToken = decode(
    JSON.parse(window.localStorage.getItem("refreshToken"))
  );
  let currentTime = new Date();
  return currentTime >= parseInt(refreshToken.expiredAt);
}

/**
 * 拦截器
 */
axios.interceptors.request.use(
  (config) => {
    const isSignIn = JSON.parse(window.localStorage.getItem("isSignIn"));
    let accessToken = window.localStorage.getItem("accessToken");
    config.headers.common["Authorization"] = JSON.parse(accessToken);
    if (isSignIn) {
      if (isRefreshTokenExpired()) {
        window.localStorage.removeItem("isSignIn");
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem("refreshToken");
        window.location.href = "/";

        return;
      }
      if (config.url.indexOf("token_refresh") !== -1) {
        config.headers.common["Authorization"] = getRefreshToken();
        return config;
      }
      if (isTokenExpired()) {
        if (!window.isRefreshing) {
          window.isRefreshing = true;
          User.refreshToken({ refreshToken: getRefreshToken() })
            .then((res) => {
              window.localStorage.setItem(
                "accessToken",
                JSON.stringify(res.data.message)
              );
              window.isRefreshing = false;
              return res.data.message;
            })
            .then((token) => {
              onRrefreshed(token);
              refreshSubscribers = [];
            })
            .catch(() => {})
            .finally(() => {
              window.isRefreshing = false;
            });
        }
        return new Promise((resolve) => {
          subscribeTokenRefresh((token) => {
            config.headers["Authorization"] = token;
            resolve(config);
          });
        });
      }
    } else {
      if (
        config.url === "/account/active" ||
        config.url === "/account/modify" ||
        config.url === "/account/find_back"
      ) {
        let accessToken = window.sessionStorage.getItem("accessToken");
        config.headers.common["Authorization"] = JSON.parse(accessToken);
      }
    }
    return config;
  },
  (error) => {
    return error;
  }
);

export default User;
